import { ORDER_BY, ResponseCode } from "@app/constants/Common";
import { requestCandidates } from '@app/services/CandidateService';
import { stringToOption } from "@app/utils/CommonUtils";
import CandidateListTable, { CandidateListMode } from "@pages/candidate/list/CandidateListTable";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const DVTJCUVSearchCddJobChooseReceiverModal = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [searchConditions, setSearchCondition] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [strServiceUseTimes, setStrServiceUseTimes] = useState('');

    const {cddId, isShow, onReturnSelectItems, onClose} = props

    const fetchCandidateList = async (canIds) => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: searchConditions
        }

        if (canIds && canIds.length > 0) {
            params.search_conditions.candidate_ids = canIds
        }
        
        params.search_conditions.unlimited = true

        const res = await requestCandidates(params);

        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        setLoading(false)
        // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    const fetchPipelines = async () => {
        const params = {
            search_conditions: {service_use_times: [], cdd_id: searchConditions.cdd_id}
        }

        if (strServiceUseTimes) {
            params.search_conditions.service_use_times = strServiceUseTimes.split(' ').map(item => item.trim()).filter(item => !!item);
        }
        params.search_conditions.cdd_emp_process = stringToOption("Brief sent", false)
        params.search_conditions.unlimited = true;

        params.search_conditions.search_receivers_for_cdd_id = cddId

        setLoading(true)
        const res = await requestGetDVTJCUVPipeLineList(params);
        if (res.sts_code === ResponseCode.SUCCESS) {
            const pipelines = res.content?.pipelines;
            const recIds = [];
            if (pipelines && pipelines.length > 0) {
                pipelines.forEach(item => {
                    if (item.cdd_receiver_id && !recIds.includes(item.cdd_receiver_id)) {
                        recIds.push(item.cdd_receiver_id);
                    }
                })
            }

            if (recIds.length > 0) {
                fetchCandidateList(recIds);
            } else {
                setCandidates([])
                setLoading(false)
            }
        }
    }

    // useEffect(() => {
    //     (async () => {
    //         await fetchOverview(cddId);
    //     })();
    // },[cddId])

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   onHide={onClose}
                   animation={false} style={{zIndex: 3004}}>
                <Modal.Header>
                    <Modal.Title>Chọn Receiver</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Danh sách Receivers</h3>
                            <div className={'card-tools w-75 row'}>
                                <div className={'col-sm-4'}>
                                    <input type='number' className='form-control'
                                           value={searchConditions.cdd_id || ''}
                                           placeholder={'Nhập cdd Id'}
                                           onChange={event => {
                                               searchConditions.cdd_id = event.target.value
                                               setSearchCondition({...searchConditions})
                                           }}/>
                                </div>
                                <div className={'col-sm-4'}>
                                    <input type='text' className='form-control'
                                           value={strServiceUseTimes}
                                           placeholder={'Nhập các lần sử dụng DV cách nhau bởi dấu cách. Ví dụ: 1 3 10'}
                                           onChange={event => setStrServiceUseTimes(event.target.value)}/>

                                </div>
                                <div className={'col-sm-4'}>
                                    <Button className={'btn btn-primary'}
                                            onClick={() => fetchPipelines()}>
                                        Search
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <CandidateListTable
                                showBtnSelect
                                hideBtnActions
                                candidates={candidates}
                                allCandidateIds={allCandidateIds}
                                mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_CHOOSE_RECEIVERS}
                                totalCount={totalCount}
                                onSaveChosenReceivers={onReturnSelectItems}
                            />

                            {isLoading &&
                                <div className={'col-sm-12 text-center'}
                                     style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                                    <div className='spinner-grow text-primary' role='status'>
                                        <span className='sr-only'>Loading...</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DVTJCUVSearchCddJobChooseReceiverModal;
